import { Admin, CustomRoutes, Layout, LayoutProps, Login, Resource } from 'react-admin';
import { ComplaintsList, ComplaintsShow, MenuLayout, UsersEdit, UsersList, UsersShow } from 'routes';
import { NotificationCreate, NotificationEdit, NotificationShow, NotificationsList } from 'routes/Notifications';
import { authProvider, dataProvider } from 'providers';

import CircleNotificationsIcon from '@mui/icons-material/CircleNotifications';
import DisputesList from 'routes/Disputes/DisputesList';
import DisputesShow from 'routes/Disputes/DisputesShow';
import FlagIcon from '@mui/icons-material/Flag';
import { MediaFiles } from 'routes/MediaFiles';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import ReportIcon from '@mui/icons-material/Report';
import { Route } from 'react-router';

const AppLayout = (props: LayoutProps) => <Layout {...props} menu={MenuLayout} />;

const App = () => (
  <Admin dataProvider={dataProvider} authProvider={authProvider} loginPage={Login} layout={AppLayout}>
    <Resource
      name="users"
      options={{ label: 'Пользователи' }}
      list={UsersList}
      show={UsersShow}
      edit={UsersEdit}
      icon={PeopleAltIcon}
    />
    <Resource
      name="complaints"
      options={{ label: 'Жалобы' }}
      list={ComplaintsList}
      show={ComplaintsShow}
      icon={ReportIcon}
    />
    <Resource
      name="notifications"
      options={{ label: 'Уведомления' }}
      list={NotificationsList}
      create={NotificationCreate}
      show={NotificationShow}
      edit={NotificationEdit}
      icon={CircleNotificationsIcon}
    />
    <Resource name="disputes" options={{ label: 'Споры' }} list={DisputesList} show={DisputesShow} icon={FlagIcon} />

    <CustomRoutes>
      <Route path="/app/media/storage" element={<MediaFiles />} />
    </CustomRoutes>
  </Admin>
);

export default App;
